import { getAreaConfig, isIframeHost } from '@rendora/common/utils/config';

//  获取前端资源的 cdn 地址
export const getFeUrl = (path: string, ts?: string) => {
  const { feOss } = getAreaConfig();
  return `${feOss}${path}${ts ? `?ts=${ts}` : ''}`;
};

// 获取服务端资源的 cdn 地址
export const getBeUrl = (path: string, ts?: string) => {
  const { beOss } = getAreaConfig();
  return `${beOss}${path}${ts ? `?ts=${ts}` : ''}`;
};

// 获取服务平台跳转地址
export const getPlatformJumpLink = (path: string, query?: string) => {
  if (isIframeHost()) {
    return `${path}${query ? `?${query}` : ''}`;
  }
  const { domain } = getAreaConfig();
  return `${domain}${path}${query ? `?${query}` : ''}`;
};

export const replaceSpaceWithUnderscore = (str: string) => {
  return str.replace(/\s+/g, '_');
};

/**
 * 构建 API URL，自动处理斜线兼容性
 * @param baseUrl 基础 URL
 * @param path 路径
 * @param params 查询参数
 * @returns 完整的 URL
 */
export function buildApiUrl(
  baseUrl: string,
  path: string,
  params?: Record<string, string | number | undefined>,
): string {
  // 确保 baseUrl 不以斜线结尾，path 以斜线开头
  const normalizedBase = baseUrl.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  let url = `${normalizedBase}${normalizedPath}`;

  // 添加查询参数
  if (params) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        searchParams.append(key, String(value));
      }
    });
    const queryString = searchParams.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
  }

  return url;
}
